import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import RoutesApp from './Routes';

ReactDOM.render(
  <React.StrictMode>
    <RoutesApp />
  </React.StrictMode>,
  document.getElementById('root')
);